import { type Epic, combineEpics } from 'redux-observable';
import type { State } from '../../state/types';
import copyRuleEpic from './copy';
import createRuleEpic from './create-rule';
import deleteRuleEpic from './delete';
import viewLogEpic from './view-log';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type StateEpic = Epic<any, State>;

const epics = combineEpics(
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	deleteRuleEpic as StateEpic,
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	copyRuleEpic as StateEpic,
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	viewLogEpic as StateEpic,
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	createRuleEpic as StateEpic,
);

export default epics;
